<div class="contenedor fade-in-left">
    <div class="d-flex align-items-center mb-0 pe-5">
        <a (click)="back()"><div class="p-2 ps-0 pb-0"><i class="bi bi-chevron-left align-middle"></i></div></a>
    </div>

    <img src="./assets/img/icon-lock-mp.svg" class="icono-candado" alt="Candado Seguridad" />

    <h1>Vinculá tu cuenta de Mercado Pago</h1>
    <p>
        Para recibir pagos de tus pacientes / clientes directamente, necesitás autorizar esta conexión segura.
    </p>

    <ul class="beneficios">
        <li>Recibir pagos directamente en su cuenta</li>
        <li>El dinero se transfiere en el momento</li>
        <li>Puede revocar el acceso cuando desee</li>
    </ul>

    <div class="seguridad">
        <div class="seguridad-texto">
            <img src="./assets/img/icon-lock-mp-s.svg" alt="Candado" class="seguridad-icono" />
            <strong class="ps-2">Esta conexión es segura</strong>
        </div>
        <div class="seguridad-texto detalle">
            Solo usaremos tu cuenta para generar y administrar los pagos desde la app.<br />
            No tenemos acceso a mover tu dinero y otras transacciones de tu cuenta de Mercado Pago.
        </div>
    </div>

    @if (error()) {
        <div class="alert alert-danger mt-3" role="alert">
        <small>{{ error() }}</small>
        </div>
    }

    <button class="btn-principal" (click)="mercadopago()" [disabled]="redirecting()">
        {{ redirecting() ? 'Redirigiendo a Mercado Pago...' : 'Continuar en Mercado Pago' }}
    </button>

    @if (redirecting()) {
        <div class="alert alert-info mt-3">
            Te estamos llevando a Mercado Pago. No cierres esta pantalla.
        </div>
    }

    <button class="btn-secundario" (click)="back()" [disabled]="loading()">
        No quiero conectar mi cuenta ahora
    </button>
</div>